import { IUser } from '@sales-center/common'
import { GridValueFormatterParams } from '@mui/x-data-grid-pro'

export const userValueFormatter = ({
  value,
}: GridValueFormatterParams): any => {
  if (!!value) {
    const { id, firstName, lastName, isActive } = value as IUser
    if (id === '00000000-0000-0000-0000-000000000000') return 'Unassigned'
    return (
      `${firstName} ${lastName}` + (isActive === false ? ' (Inactive)' : '')
    )
  }
}
